function Menu(props) {
    return null;
}
Menu.symbol = 'Menu';

export { Menu as default };
